const {
  adminUrl,
  ajaxUrl,
  restUrl,
  backgroundIframeUrl,
  deviceId,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hublet,
  hubspotBaseUrl,
  impactLink,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  ajaxNonce,
  restNonce,
  routeNonce,
  redirectNonce,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  reviewSkippedDate,
  theme,
  wpVersion,
  portalDomain,
  leadinQueryParamsKeys,
  oauth,
  trackConsent,
  connectionStatus,
} = window.leadinConfig;

const i18n = window.leadinI18n;

export {
  adminUrl,
  ajaxUrl,
  restUrl,
  backgroundIframeUrl,
  deviceId,
  didDisconnect,
  env,
  formsScript,
  formsScriptPayload,
  hublet,
  hubspotBaseUrl,
  i18n,
  impactLink,
  leadinPluginVersion,
  loginUrl,
  pluginPath,
  ajaxNonce,
  restNonce,
  routeNonce,
  redirectNonce,
  reviewSkippedDate,
  plugins,
  phpVersion,
  portalId,
  portalEmail,
  iframeUrl,
  accountName,
  routes,
  theme,
  wpVersion,
  portalDomain,
  leadinQueryParamsKeys,
  oauth,
  trackConsent,
  connectionStatus,
};
